module.exports = __webpack_public_path__ + "img/opthonlogo.12b7d564.png";